import { render, staticRenderFns } from "./ImgTextList.vue?vue&type=template&id=3efe834e&scoped=true"
import script from "./ImgTextList.vue?vue&type=script&lang=js"
export * from "./ImgTextList.vue?vue&type=script&lang=js"
import style0 from "./ImgTextList.vue?vue&type=style&index=0&id=3efe834e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efe834e",
  null
  
)

export default component.exports